import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSunDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 24,
	viewBox: "0 0 32 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2868_9089)",
		children: [/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_2868_9089)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M16.0295 13.2872C21.148 13.269 25.3145 17.3989 25.3416 22.5173C25.3686 27.6357 21.246 31.8094 16.1276 31.8454C10.9966 31.8814 6.81045 27.7464 6.78334 22.6154C6.75622 17.4844 10.8984 13.3054 16.0295 13.2872Z",
					fill: "url(#paint0_linear_2868_9089)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M3.89334 20.7656C3.95791 20.7698 4.02294 20.7782 4.08416 20.8003C4.17143 20.8318 4.2531 20.9006 4.29012 20.9868C4.36876 21.1699 4.37121 23.3382 4.35122 23.6831C4.34533 23.7849 4.33903 23.8955 4.29801 23.9898C4.23429 24.136 4.11622 24.1966 3.97603 24.2546C3.641 24.2208 3.12362 23.9824 2.80049 23.851L1.52881 23.337C1.21836 23.2121 0.924273 23.0936 0.598449 22.9594C0.363988 22.8628 0.0123991 22.7165 0.222649 22.3767C0.249396 22.3334 0.317693 22.2792 0.365501 22.258C0.824813 22.0546 1.29181 21.8686 1.75354 21.67L2.93549 21.1489C3.1756 21.0416 3.65675 20.8035 3.89334 20.7656Z",
					fill: "#FE9D00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.1768 20.7637C28.4069 20.7736 28.6987 20.9079 28.9079 21.0075C29.8439 21.4529 30.8095 21.8316 31.7562 22.2506C31.8938 22.2741 32.0624 22.5352 31.9775 22.6659C31.7914 22.9524 30.9646 23.2023 30.6628 23.3259L29.2859 23.8796C29.0161 23.9875 28.7358 24.1033 28.461 24.1951C28.3398 24.2356 28.1866 24.2724 28.0716 24.2118C27.97 24.1583 27.8478 24.0244 27.8346 23.911C27.7856 23.4885 27.8083 22.9908 27.8061 22.5634C27.8134 22.1205 27.7957 21.6753 27.8185 21.233C27.832 20.9704 27.914 20.8267 28.1768 20.7637Z",
					fill: "#FE9D00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.8924 10.8633C26.9391 10.8677 26.9982 10.8753 27.0375 10.9027C27.0914 10.9403 27.1219 10.9862 27.1294 11.0524C27.139 11.1372 27.1141 11.2276 27.0876 11.3073C26.9921 11.5945 25.7488 14.5829 25.6372 14.7096C25.5689 14.7872 25.4449 14.8307 25.3439 14.8359C25.0983 14.8484 24.5965 14.2787 24.4079 14.0934C24.1338 13.8228 23.8474 13.5446 23.568 13.2791C23.0038 12.7429 23.7399 12.4929 24.1629 12.2676L25.1998 11.7186L26.1802 11.2033C26.3878 11.0947 26.6756 10.9356 26.8924 10.8633Z",
					fill: "#FE9D00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.14698 10.8652C5.59014 10.9319 6.91372 11.7505 7.4275 11.9973C9.34896 12.9201 8.99209 12.8695 7.79815 14.0196C7.57535 14.2371 7.35373 14.4581 7.12258 14.6651C7.00107 14.8014 6.60151 14.9257 6.48917 14.7108C5.99223 13.7604 5.65594 12.697 5.21364 11.7157C5.1489 11.5721 5.10081 11.4247 5.05079 11.2812C4.98364 11.0884 4.9371 10.9724 5.14698 10.8652Z",
					fill: "#FE9D00"
				})
			]
		}), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.5917 10.4415C15.8261 10.6758 16.2061 10.6758 16.4404 10.4415L19.3574 7.52544C19.5916 7.29115 19.5916 6.91111 19.3574 6.6768C19.1231 6.44252 18.743 6.44253 18.5087 6.6768L16.621 8.5645V3.59965C16.6208 3.26846 16.3527 3.00005 16.0214 3.00005C15.6902 3.00005 15.422 3.26846 15.4218 3.59965V8.57622L13.5234 6.6768C13.2891 6.44265 12.91 6.44266 12.6757 6.6768C12.4414 6.91111 12.4414 7.29112 12.6757 7.52544L15.5917 10.4415Z",
			fill: "#DFCBF5",
			fillOpacity: .8
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_2868_9089",
			x1: 9.98477,
			y1: 29.5088,
			x2: 22.109,
			y2: 15.5508,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#ED6000" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FFB100"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_2868_9089",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 24,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_2868_9089",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 32,
				fill: "white",
				transform: "translate(0 6)"
			})
		})
	] })]
});
export default SvgSunDown;
